/* Logo eines Vereins im Register hochladen — reine Funktionen; Upload und Verkleinern werden hereingereicht,
 * damit alles ohne Browser prüfbar ist.
 *
 * Ablauf: prüfen (Bild? SVG höchstens 100 KB?) -> auf höchstens 256 px verkleinern (composables/shrinkLogo.js,
 * Regeln in domain/logoShrink.js) -> prüfen (höchstens 1 MB, SVG 100 KB) -> hochladen nach
 * avatars/clubs/<vereinsId>/. Wirft Error('logoNotImage' | 'logoTooLarge' | 'logoSvgTooLarge' | 'uploadFailed' …);
 * die Schlüssel stehen unter errors.* in den Sprachdateien.
 *
 * Es wird nie eine Datei gelöscht. Ersetzt ein neues Logo ein altes, bleibt die alte Datei im Speicher liegen
 * (Entscheidung Bastian, N7: Altdateien bleiben).
 */

import { logoInputProblem, logoOutputProblem } from './logoShrink.js';
import { registerLogoFolder } from './footballClub.js';

/** Datei prüfen und verkleinern. Gibt die Datei zurück, die hochgeladen werden soll. Wirft bei Verstoß. */
export async function prepareRegisterLogo(file, shrink = async (f) => f) {
  const before = logoInputProblem(file);
  if (before) throw new Error(before);
  const prepared = await shrink(file);
  const after = logoOutputProblem(prepared);
  if (after) throw new Error(after);
  return prepared;
}

/**
 * Logo eines Vereins hochladen (Ordner avatars/clubs/<vereinsId>). `upload(file, folder)` ist
 * useFileActions().upload. Liefert { path, filename }. Wirft vor dem Hochladen, wenn die Datei nicht zulässig ist.
 */
export async function uploadRegisterLogo(clubId, file, upload, shrink) {
  const prepared = await prepareRegisterLogo(file, shrink);
  return upload(prepared, registerLogoFolder(clubId));
}
